import React, { useState } from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import styled from 'styled-components';

import { PlayButtonIcon } from '../icons/playButtonIcon';
import { PauseButtonIcon } from '../icons/PauseButtonIcon';
import { commonTooltipInlineStyle } from '../utilities/constants';

interface AnimationWidgetProps {
    animationEnabled: boolean;
    animationTime: number;
    animationCallback: () => void;
    progressPercentage: number;
    isAnimating: boolean;
}

const animateButtonTooltipId = 'animate-button-tool-tip';
const animateButtonTooltipInlineStyle = { 
    ...commonTooltipInlineStyle,
    width: 130,
    zIndex: 9999
};

export const AnimationWidget = ({
    animationEnabled,
    animationTime,
    animationCallback,
    progressPercentage,
    isAnimating
}: AnimationWidgetProps) => {
    const onClick = () => {
        if (animationEnabled) {
            if (animationCallback) {
                animationCallback();
            }
        }
    };

    return (
        <Container
            animationEnabled={animationEnabled}
            onClick={() => {onClick();}}
            data-tooltip-id={animateButtonTooltipId}
        >
            <ReactTooltip 
                style={animateButtonTooltipInlineStyle} 
                place='top-start'
                content='Animate'
                id={animateButtonTooltipId} />
            {!animationTime && <PlayButtonIcon/>}
            {animationTime 
                && <div>
                    <TopContainer>
                        {!isAnimating && <PlayButtonIcon/>}
                        {isAnimating && <PauseButtonIcon/>} 
                        <TextSpan>{animationTime}</TextSpan>
                    </TopContainer>
                    <ProgressContainer>
                        <ProgressBar progressPercentage={progressPercentage}/>
                    </ProgressContainer>
                </div>
            }
        </Container>
    );
};

interface ContainerProp {
    animationEnabled: boolean;
}
const Container = styled.div<ContainerProp>`
    width: 106px;
    height: 46px;
    background-color: #FFFFFF;
    color: #666666;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    cursor: ${({ animationEnabled }) => animationEnabled ? 'pointer' : 'not-allowed'};
`;

const TopContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-bottom: 4px;
    height: 23px;
`;

const TextSpan = styled.span`
    color: #666666;
    font-size: 15px;
    margin-left: 3px;
`;

const ProgressContainer = styled.div`
    height: 3px;
    background-color: #D8D8D8;
`;

interface ProgressBarProp {
    progressPercentage: number;
}
const ProgressBar = styled.div<ProgressBarProp>`
    height: 100%;
    background-color: #2e98e3;
    width: ${({ progressPercentage }) => progressPercentage + '%'};
`;
